import { render, staticRenderFns } from "./syUserAdmin.vue?vue&type=template&id=0a0f315a&"
import script from "./syUserAdmin.vue?vue&type=script&lang=js&"
export * from "./syUserAdmin.vue?vue&type=script&lang=js&"
import style0 from "./syUserAdmin.vue?vue&type=style&index=0&id=0a0f315a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports